module.exports = __webpack_public_path__ + "static/media/logo-ai2-fullColor-withText.8255da7c.svg";